export default __webpack_public_path__ + "static/media/ele_example_2_2.c782bc0c.png";